import { render, staticRenderFns } from "./PedidosCompraLista.vue?vue&type=template&id=64e17294&scoped=true&"
import script from "./PedidosCompraLista.vue?vue&type=script&lang=js&"
export * from "./PedidosCompraLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e17294",
  null
  
)

export default component.exports